import __ from "web/Layout/Translations";

import getSubscriptionChoiceUrl from "web/utils/page/product/subscription/getSubscriptionChoiceUrl";

import urls from "web/constants/urls";

import { Functionality } from "web/types/Employee";
import { ICategoryFunctionalityMenuItem } from "web/types/Menu";

import type { SubscriptionQuoteConfig } from "web/features/subscriptionQuote/subscriptionQuoteSlice";

interface IHandleCategoryFunctionalityArgs {
  menuItem: ICategoryFunctionalityMenuItem;
  hasEnabledAnySubscriptions: boolean;
  subscriptionConfig: SubscriptionQuoteConfig;
}

const handleCategoryFunctionality = ({
  menuItem,
  hasEnabledAnySubscriptions,
  subscriptionConfig,
}: IHandleCategoryFunctionalityArgs) => {
  if (!menuItem.category_functionality) {
    return null;
  }
  switch (true) {
    case menuItem.category_functionality === Functionality.SUBSCRIPTIONS &&
      hasEnabledAnySubscriptions:
      return {
        ...menuItem,
        submenu: [
          {
            title: __("Wybierz abonamenty"),
            url: getSubscriptionChoiceUrl(
              subscriptionConfig.configuratorWindowOpen,
              subscriptionConfig.configuratorWindowOpenUms
            ),
          },
          {
            title: __("Moje abonamenty"),
            url: urls.customerSubscriptions,
          },
          {
            title: __("Katalog abonamentów"),
            url: "/abonamenty.html",
          },
        ],
        url: "",
        title: menuItem.title,
      };
    default:
      return null;
  }
};

export default handleCategoryFunctionality;
